import React from "react";

export default function MySQL_DATE_SUB() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_DATE_SUB</h1>
      <p>This is the MySQL_DATE_SUB component generated from the SQL JSON.</p>
    </div>
  );
}
